var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "mb-20", attrs: { shadow: "never" } },
        [
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { gutter: 12, justify: "space-between", type: "flex" }
            },
            [
              _c("el-col", { attrs: { span: 4 } }, [
                _vm._v(" 差异单号： " + _vm._s(_vm.supply_feedback_dif.id))
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 18 } }, [
                _vm._v(
                  "\n        处理状态：" +
                    _vm._s(_vm.supply_feedback_dif.verify_status_txt) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { type: "text" },
                      on: { click: _vm.fetchData }
                    },
                    [_vm._v("刷新")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "card-style",
          attrs: { shadow: "never" }
        },
        [
          _c("el-col", { staticClass: "col-style", attrs: { span: 24 } }, [
            _c("div", { staticClass: "bold-title" }, [_vm._v("商家反馈差异")])
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "col-style", attrs: { span: 24 } },
            [
              _c("div", { staticClass: "table-title" }, [_vm._v("包裹信息")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: "table1",
                  staticStyle: { width: "100%" },
                  attrs: { data: [_vm.supply_feedback_dif], border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_type_txt",
                      label: "包裹类型",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_no",
                      label: "包裹号",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "spr_create_time",
                      label: "包裹生成时间",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supply_id",
                      label: "商家ID",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supply_name",
                      label: "商家",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "billing_type_txt",
                      label: "开单方式",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "market_name",
                      label: "市场",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "city_txt", label: "城市", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "pg_name", label: "代采组", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pg_member_name",
                      label: "代采员",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "user_name",
                      label: "商家反馈人",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(row.user_name) +
                                  "（爆版id：" +
                                  _vm._s(row.user_id) +
                                  "）"
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: "商家反馈时间",
                      align: "center"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "div",
                {
                  staticClass: "table-title",
                  on: {
                    click: function($event) {
                      return _vm.toggleFilter("difGoodsTogglle")
                    }
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _vm._v("\n          差异商品信息\n          "),
                      _c("el-button", {
                        attrs: {
                          type: "text",
                          icon: _vm.toggle.difGoodsTogglle
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleDifGoodsExport }
                    },
                    [_vm._v("导出")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.toggle.difGoodsTogglle,
                        expression: "toggle.difGoodsTogglle"
                      }
                    ],
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "80%" } },
                      [
                        _c(
                          "el-table",
                          {
                            key: "table2",
                            staticStyle: { width: "70%" },
                            attrs: {
                              data: _vm.processedTableData,
                              border: "",
                              "max-height": "400px",
                              "span-method": _vm.arraySpanMethod,
                              "header-cell-class-name": _vm.addColor,
                              "cell-class-name": _vm.addColor
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                fixed: "left",
                                prop: "img",
                                label: "商品图片",
                                align: "center",
                                width: "90"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "viewer",
                                              rawName: "v-viewer"
                                            }
                                          ],
                                          staticStyle: {
                                            width: "60px",
                                            height: "60px",
                                            overflow: "hidden",
                                            cursor: "pointer"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%"
                                            },
                                            attrs: { src: row.main_img }
                                          })
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center",
                                width: "120"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center",
                                width: "120"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sku",
                                label: "SKU",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.sku) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.co_val) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.si_val) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "stock_num",
                                label: "一手入库数（商家反馈时）",
                                align: "center",
                                width: "110"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(row.stock_num) +
                                            "\n                  "
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "current_num",
                                label: "一手入库数（当前实时）",
                                align: "center",
                                width: "110"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.current_num) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "商家配货数",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.num) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "feedback_num",
                                  width: "100",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("NumColorCell", {
                                          attrs: { num: row.feedback_num || "" }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c("div", [_vm._v("反馈时入库件数差异")]),
                                    _vm._v(" "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            "反馈时入库差异件数 = 商家反馈时的一手已入库件数 - 商家配货件数",
                                          placement: "top-start"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-question"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "in_feedback_num",
                                  align: "center",
                                  fixed: "right"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return [
                                        _c("NumColorCell", {
                                          attrs: {
                                            num: row.in_feedback_num || ""
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c("div", [_vm._v("当前入库件数差异")]),
                                    _vm._v(" "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            "当前入库差异件数 = 当前实时的一手已入库件数 - 商家配货件数",
                                          placement: "top-start"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-question"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            key: "table3",
                            staticStyle: { width: "70%" },
                            attrs: {
                              data: _vm.amountTableData,
                              border: "",
                              "show-header": false,
                              "cell-class-name": _vm.addColor
                            }
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  prop: "img",
                                  label: "",
                                  align: "center",
                                  width: "90",
                                  fixed: "left"
                                }
                              },
                              [_vm._v("\n                合计\n              ")]
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "",
                                label: "",
                                align: "center",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "",
                                label: "",
                                align: "center",
                                width: "120"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "",
                                label: "",
                                align: "center",
                                width: "120"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "",
                                label: "",
                                align: "center",
                                width: "100"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "",
                                label: "",
                                align: "center",
                                width: "100"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "",
                                label: "",
                                align: "center",
                                width: "100"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "stock_num",
                                align: "center",
                                width: "110"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.stock_num) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "current_num",
                                align: "center",
                                width: "110"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.current_num) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.num) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "",
                                width: "100",
                                align: "center"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c("NumColorCell", {
                                        attrs: { num: row.feedback_num || "" }
                                      })
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "in_feedback_num",
                                align: "center",
                                fixed: "right"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c("NumColorCell", {
                                        attrs: {
                                          num: row.current_feedback_num || ""
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { width: "20%" } },
                      [
                        _c(
                          "el-table",
                          {
                            key: "table4",
                            attrs: {
                              border: "",
                              width: "100%",
                              data: [_vm.supply_feedback_dif]
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "imgs",
                                label: "商家提交的配货凭证",
                                align: "center",
                                height: "100"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "viewer",
                                              rawName: "v-viewer"
                                            }
                                          ],
                                          staticClass: "voucher-box",
                                          staticStyle: { width: "100%" }
                                        },
                                        _vm._l(_vm.viewImg, function(
                                          item,
                                          index
                                        ) {
                                          return _c("img", {
                                            key: item + index,
                                            staticClass: "viewer-img",
                                            attrs: { src: item }
                                          })
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "voucher--video-box" },
                                        _vm._l(_vm.viewVideo, function(
                                          item,
                                          index
                                        ) {
                                          return _c("video", {
                                            key: item + index,
                                            staticClass: "viewer-video",
                                            attrs: {
                                              width: "250",
                                              src: item,
                                              controls: ""
                                            }
                                          })
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _vm.supply_feedback_dif
                                        .description_of_differences
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                                "font-size": "14px",
                                                "padding-top": "10px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "#BCBCBC"
                                                  }
                                                },
                                                [_vm._v("差异反馈补充说明：")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "black"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.supply_feedback_dif
                                                        .description_of_differences
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "card-style", attrs: { shadow: "never" } },
        [
          _c("el-col", { staticClass: "col-style", attrs: { span: 24 } }, [
            _c(
              "div",
              {
                staticClass: "table-title",
                on: {
                  click: function($event) {
                    return _vm.toggleFilter("supplyPackageTogglle")
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _vm._v("\n          商家当天包裹入库信息\n          "),
                    _c("el-button", {
                      attrs: {
                        type: "text",
                        icon: _vm.toggle.supplyPackageTogglle
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      }
                    }),
                    _vm._v(" "),
                    _vm.supply_feedback_dif.package_type ===
                    _vm.constantMap.package_type.MASS_GOODS
                      ? _c("div", { staticStyle: { "margin-left": "30px" } }, [
                          _vm._v(
                            "\n            商家当天开单：" +
                              _vm._s(_vm.supply_feedback_dif.day_total_num) +
                              " 件\n          "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "el-collapse-transition",
            [
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.toggle.supplyPackageTogglle,
                      expression: "toggle.supplyPackageTogglle"
                    }
                  ],
                  staticClass: "col-style",
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activeTab,
                        callback: function($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "按包裹", name: "package" } },
                        [
                          !_vm.loading
                            ? _c("InventoryByPackage", {
                                attrs: { "form-props": _vm.formProps }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "按入库商品", name: "goods" } },
                        [
                          !_vm.loading
                            ? _c("InventoryByGoods", {
                                attrs: { "form-props": _vm.formProps }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: "商家反馈缺漏商品（一手无入库）",
                            name: "lackGoods"
                          }
                        },
                        [
                          !_vm.loading
                            ? _c("InventoryByLackGoods", {
                                attrs: { "form-props": _vm.formProps }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "card-style", attrs: { shadow: "never" } },
        [
          _c("el-col", { staticClass: "col-style", attrs: { span: 24 } }, [
            _c(
              "div",
              {
                staticClass: "table-title",
                on: {
                  click: function($event) {
                    return _vm.toggleFilter("WarehouseVerifyToggle")
                  }
                }
              },
              [
                _c(
                  "div",
                  [
                    _vm._v("\n          仓库核实\n          "),
                    _c("el-button", {
                      attrs: {
                        type: "text",
                        icon: _vm.toggle.WarehouseVerifyToggle
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "el-collapse-transition",
            [
              _c(
                "el-form",
                {
                  ref: "warehouseVerifyForm",
                  attrs: {
                    model: _vm.warehouse_verify_data,
                    rules: _vm.warehouseVerifyFormRules
                  }
                },
                [
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.toggle.WarehouseVerifyToggle,
                          expression: "toggle.WarehouseVerifyToggle"
                        }
                      ],
                      staticClass: "col-style ml-20 pr-20",
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-20" },
                        [
                          _c("div", [
                            _vm._v("仓库核实说明（回复商家，商家可见）")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "warehouse_verify_explain" } },
                            [
                              _c("ys-input", {
                                attrs: {
                                  placeholder: "请填写核实说明，商家可见",
                                  type: "textarea",
                                  "show-word-limit": "",
                                  rows: "3",
                                  disabled:
                                    _vm.supply_feedback_dif.verify_status !==
                                    _vm.constantMap.verify_status.TO_BE_VERIFIED
                                },
                                model: {
                                  value:
                                    _vm.warehouse_verify_data
                                      .warehouse_verify_explain,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.warehouse_verify_data,
                                      "warehouse_verify_explain",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "warehouse_verify_data.warehouse_verify_explain"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.supply_feedback_dif.verify_status ===
                      _vm.constantMap.verify_status.TO_BE_VERIFIED
                        ? _c(
                            "div",
                            { staticClass: "mb-20" },
                            [
                              _c("div", [
                                _vm._v("上传仓库点货凭证（商家可见）")
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "warehouse_imgs" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          style: "width:100%;",
                                          attrs: { span: 24 }
                                        },
                                        [
                                          _c(
                                            "el-upload",
                                            {
                                              staticClass: "upload-demo",
                                              attrs: {
                                                "show-file-list": false,
                                                action: _vm.action,
                                                multiple: "",
                                                accept: "image/*",
                                                "on-success":
                                                  _vm.uploadSuccessImg,
                                                "on-remove":
                                                  _vm.handleRemoveImg,
                                                "on-exceed":
                                                  _vm.handleExceedImg,
                                                "file-list": _vm.imgFileList,
                                                limit: _vm.constantMap.limit,
                                                disabled: _vm.videoFlag,
                                                "on-change":
                                                  _vm.handleChangeImg,
                                                "on-error": _vm.handleErrorImg,
                                                "with-credentials": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    margin: "10px 3px"
                                                  },
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      上传图片\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.verifyVoucherImg.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "viewer",
                                                        rawName: "v-viewer"
                                                      }
                                                    ],
                                                    staticClass: "viewer-box",
                                                    staticStyle: {
                                                      width: "100%"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.verifyVoucherImg,
                                                    function(item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: item + index,
                                                          staticStyle: {
                                                            position: "relative"
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "viewer-img",
                                                            attrs: {
                                                              src:
                                                                _vm.origin +
                                                                "/" +
                                                                item.url
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-circle-close delete-icon",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.handleDelImages(
                                                                  item,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("el-col", [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#999" } },
                                          [
                                            _vm._v(
                                              "\n                    单张图片不要超过10M，最多可上传5张图片\n                  "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          style: "width:100%;",
                                          attrs: { span: 24 }
                                        },
                                        [
                                          _c(
                                            "el-upload",
                                            {
                                              staticClass: "upload-demo",
                                              staticStyle: {
                                                display: "inline-block",
                                                "margin-right": "10px"
                                              },
                                              style:
                                                "width:100px;float:left;height:50px;",
                                              attrs: {
                                                "show-file-list": false,
                                                action: _vm.uploadActionUrl,
                                                data: _vm.uploadData,
                                                multiple: "",
                                                limit: _vm.constantMap.limit,
                                                accept: "video/*",
                                                "on-success":
                                                  _vm.uploadSuccessVideo,
                                                "before-upload":
                                                  _vm.beforeVideoUpload,
                                                "on-progress":
                                                  _vm.uploadVideoProcess,
                                                "on-exceed":
                                                  _vm.handleVideoExceed,
                                                "file-list": _vm.videoFileList
                                              }
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    margin: "10px 3px"
                                                  },
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      上传视频\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.verifyVoucherVideo.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                      display: "flex",
                                                      overflow: "auto"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.verifyVoucherVideo,
                                                    function(item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: item + index,
                                                          staticStyle: {
                                                            position: "relative"
                                                          }
                                                        },
                                                        [
                                                          _c("video", {
                                                            staticClass:
                                                              "viewer-video",
                                                            attrs: {
                                                              src:
                                                                _vm.origin +
                                                                "/" +
                                                                item.url,
                                                              width: "250",
                                                              controls: ""
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-circle-close video-delete-icon",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.handleDelVideos(
                                                                  item,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.videoFlag == true
                                            ? _c("el-progress", {
                                                staticStyle: {
                                                  "margin-top": "30px"
                                                },
                                                attrs: {
                                                  type: "circle",
                                                  percentage:
                                                    _vm.videoUploadPercent
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("el-col", [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#999" } },
                                          [
                                            _vm._v(
                                              "\n                    单个视频不要超过100M，最多可上传5个视频\n                  "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      ![_vm.constantMap.verify_status.TO_BE_VERIFIED].includes(
                        _vm.supply_feedback_dif.verify_status
                      )
                        ? _c("div", { staticClass: "mb-20" }, [
                            _c("div", [_vm._v("仓库点货凭证（商家可见）")]),
                            _vm._v(" "),
                            _vm.verifyVoucherImgSupply.length > 0
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      { name: "viewer", rawName: "v-viewer" }
                                    ],
                                    staticClass: "viewer-box media-box"
                                  },
                                  _vm._l(_vm.verifyVoucherImgSupply, function(
                                    item,
                                    index
                                  ) {
                                    return _c("img", {
                                      key: index,
                                      staticClass: "viewer-img",
                                      attrs: { src: item }
                                    })
                                  }),
                                  0
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.verifyVoucherVideoSupply.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "viewer-box media-box" },
                                  _vm._l(_vm.verifyVoucherVideoSupply, function(
                                    item,
                                    index
                                  ) {
                                    return _c("video", {
                                      key: item + index,
                                      staticClass: "viewer-video-small",
                                      attrs: {
                                        controls: "",
                                        width: "150",
                                        src: item
                                      }
                                    })
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mb-20" },
                        [
                          _c("div", [_vm._v("仓库核实说明（仅内部可见）")]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "warehouse_verify_explain_private"
                              }
                            },
                            [
                              _c("ys-input", {
                                attrs: {
                                  placeholder: "请填写核实说明，仅内部可见",
                                  type: "textarea",
                                  "show-word-limit": "",
                                  rows: "3",
                                  disabled:
                                    _vm.supply_feedback_dif.verify_status !==
                                    _vm.constantMap.verify_status.TO_BE_VERIFIED
                                },
                                model: {
                                  value:
                                    _vm.warehouse_verify_data
                                      .warehouse_verify_explain_private,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.warehouse_verify_data,
                                      "warehouse_verify_explain_private",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                  warehouse_verify_data.warehouse_verify_explain_private\n                "
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      ![_vm.constantMap.verify_status.TO_BE_VERIFIED].includes(
                        _vm.supply_feedback_dif.verify_status
                      )
                        ? _c("div", { staticClass: "mb-20" }, [
                            _c("div", { staticClass: "cell-box" }, [
                              _c("div", [
                                _vm._v(
                                  "\n                仓库核实人： " +
                                    _vm._s(
                                      _vm.supply_feedback_dif
                                        .warehouse_admin_name
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                仓库核实时间：\n                " +
                                    _vm._s(
                                      _vm.supply_feedback_dif
                                        .warehouse_verify_time_txt
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.supply_feedback_dif.verify_status ===
                      _vm.constantMap.verify_status.TO_BE_VERIFIED
                        ? _c(
                            "div",
                            { staticClass: "center-flex-box" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleVerfiy }
                                },
                                [_vm._v("核实处理")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div")
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      [
        _vm.constantMap.verify_status.DEALED,
        _vm.constantMap.verify_status.TO_BE_DEALED
      ].includes(_vm.supply_feedback_dif.verify_status)
        ? _c(
            "el-card",
            { staticClass: "card-style", attrs: { shadow: "never" } },
            [
              _c("el-col", { staticClass: "col-style", attrs: { span: 24 } }, [
                _c(
                  "div",
                  {
                    staticClass: "table-title",
                    on: {
                      click: function($event) {
                        return _vm.toggleFilter("supplyAppealToggle")
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _vm._v("\n          商家申诉\n          "),
                        _c("el-button", {
                          attrs: {
                            type: "text",
                            icon: _vm.toggle.supplyAppealToggle
                              ? "el-icon-arrow-down"
                              : "el-icon-arrow-up"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-collapse-transition",
                [
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.toggle.supplyAppealToggle,
                          expression: "toggle.supplyAppealToggle"
                        }
                      ],
                      staticClass: "col-style ml-20 pr-20",
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-20" },
                        [
                          _c("div", [_vm._v("商家申诉说明")]),
                          _vm._v(" "),
                          _c("ys-input", {
                            attrs: {
                              type: "textarea",
                              "show-word-limit": "",
                              rows: "3",
                              disabled: ""
                            },
                            model: {
                              value:
                                _vm.supply_feedback_dif
                                  .supply_reason_application,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.supply_feedback_dif,
                                  "supply_reason_application",
                                  $$v
                                )
                              },
                              expression:
                                "supply_feedback_dif.supply_reason_application"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-20" }, [
                        _c("div", [_vm._v("商家补充凭证")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ],
                            staticClass: "viewer-box media-box"
                          },
                          _vm._l(_vm.supplyAppealImg, function(item, index) {
                            return _c("img", {
                              key: index,
                              staticClass: "viewer-img",
                              attrs: { src: item }
                            })
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.supplyAppealVideo.length > 0
                          ? _c(
                              "div",
                              { staticClass: "viewer-box media-box" },
                              _vm._l(_vm.supplyAppealVideo, function(
                                item,
                                index
                              ) {
                                return _c("video", {
                                  key: item + index,
                                  staticClass: "viewer-video-small",
                                  attrs: {
                                    controls: "",
                                    width: "150",
                                    src: item
                                  }
                                })
                              }),
                              0
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-20" }, [
                        _c("div", { staticClass: "cell-box" }, [
                          _c("div", [
                            _vm._v(
                              "\n              申诉人： " +
                                _vm._s(_vm.supply_feedback_dif.supply_reason) +
                                "（爆版id：" +
                                _vm._s(
                                  _vm.supply_feedback_dif.supply_reason_id
                                ) +
                                "）\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n              申诉时间： " +
                                _vm._s(
                                  _vm.supply_feedback_dif.supply_reason_time_txt
                                ) +
                                "\n            "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div")
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      [
        _vm.constantMap.verify_status.DEALED,
        _vm.constantMap.verify_status.TO_BE_DEALED
      ].includes(_vm.supply_feedback_dif.verify_status)
        ? _c(
            "el-card",
            { staticClass: "card-style", attrs: { shadow: "never" } },
            [
              _c("el-col", { staticClass: "col-style", attrs: { span: 24 } }, [
                _c(
                  "div",
                  {
                    staticClass: "table-title",
                    on: {
                      click: function($event) {
                        return _vm.toggleFilter("ysAppealToggle")
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _vm._v("\n          一手申诉处理\n          "),
                        _c("el-button", {
                          attrs: {
                            type: "text",
                            icon: _vm.toggle.ysAppealToggle
                              ? "el-icon-arrow-down"
                              : "el-icon-arrow-up"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-collapse-transition",
                [
                  _c(
                    "el-form",
                    {
                      ref: "complainForm",
                      attrs: {
                        model: _vm.complain_handling_data,
                        rules: _vm.complainFormRules
                      }
                    },
                    [
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.toggle.ysAppealToggle,
                              expression: "toggle.ysAppealToggle"
                            }
                          ],
                          staticClass: "col-style ml-20 pr-20",
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mb-20",
                              staticStyle: { display: "flex" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "40px",
                                    "line-height": "40px"
                                  }
                                },
                                [_vm._v("责任承担方：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "responsible_party_type" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: [
                                          _vm.constantMap.verify_status.DEALED
                                        ].includes(
                                          _vm.supply_feedback_dif.verify_status
                                        )
                                      },
                                      model: {
                                        value:
                                          _vm.complain_handling_data
                                            .responsible_party_type,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.complain_handling_data,
                                            "responsible_party_type",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "complain_handling_data.responsible_party_type"
                                      }
                                    },
                                    _vm._l(
                                      _vm.constantMap.responsible_party_options,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mb-20" },
                            [
                              _c("div", [
                                _vm._v("申诉处理说明（回复商家，商家可见）")
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "complain_handling_explain" }
                                },
                                [
                                  _c("ys-input", {
                                    attrs: {
                                      placeholder: "请填写处理说明",
                                      type: "textarea",
                                      "show-word-limit": "",
                                      rows: "3",
                                      disabled: [
                                        _vm.constantMap.verify_status.DEALED
                                      ].includes(
                                        _vm.supply_feedback_dif.verify_status
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.complain_handling_data
                                          .complain_handling_explain,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.complain_handling_data,
                                          "complain_handling_explain",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "complain_handling_data.complain_handling_explain"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mb-20" },
                            [
                              _c("div", [_vm._v("申诉处理说明（仅内部可见）")]),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "complain_handling_explain_private"
                                  }
                                },
                                [
                                  _c("ys-input", {
                                    attrs: {
                                      placeholder: "请填写处理说明",
                                      type: "textarea",
                                      "show-word-limit": "",
                                      rows: "3",
                                      disabled: [
                                        _vm.constantMap.verify_status.DEALED
                                      ].includes(
                                        _vm.supply_feedback_dif.verify_status
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.complain_handling_data
                                          .complain_handling_explain_private,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.complain_handling_data,
                                          "complain_handling_explain_private",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n                  complain_handling_data.complain_handling_explain_private\n                "
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          [_vm.constantMap.verify_status.DEALED].includes(
                            _vm.supply_feedback_dif.verify_status
                          )
                            ? _c("div", { staticClass: "mb-20" }, [
                                _c("div", { staticClass: "cell-box" }, [
                                  _c("div", [
                                    _vm._v(
                                      "\n                申诉处理人：\n                " +
                                        _vm._s(
                                          _vm.supply_feedback_dif
                                            .complain_handling_admin_name
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n                申诉处理时间：\n                " +
                                        _vm._s(
                                          _vm.supply_feedback_dif
                                            .complain_handling_time_txt
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          [_vm.constantMap.verify_status.TO_BE_DEALED].includes(
                            _vm.supply_feedback_dif.verify_status
                          )
                            ? _c(
                                "div",
                                { staticClass: "center-flex-box" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.handleComplain }
                                    },
                                    [_vm._v("申诉处理")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-760c2d88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760c2d88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/receiveGoods/StockVarianceProcess/StockVarianceProcessDetail.vue
// module id = null
// module chunks = 